
import React from 'react'
import Preloader from './PageComponents/Preloader'
import Header from './PageComponents/Header'
import Footer from './PageComponents/Footer'

function Marketing() {
  return (
    <div>
        {/* <Preloader/> */}

   <Header/>
  <br/>
    <br/><br/>
    <br/><br/>
    <br/>
  <div className="mainDiv fadeIn" id="top" data-wow-duration="1s" data-wow-delay="0.5s" style={{margin: '2%'}}>
    <div className="container">
      <h2>Introduction</h2>
      <p>Welcome to VoteVocal, your go-to platform for engaging in democratic processes and expressing your voice through voting.</p>
      
      <h2>Our Commitment</h2>
      <p>At VoteVocal, we are committed to protecting your privacy and ensuring that your personal information is handled responsibly. This marketing policy outlines how we collect, use, and protect your data when you use our mobile application.</p>

      <h2>Data Collection</h2>
      <p>We collect personal information, such as your name, email address, and location, to provide you with personalized services and improve your user experience. We may also collect non-personal information, such as device information and usage data, to analyze trends and optimize our services.</p>

      <h2>Data Usage</h2>
      <p>We use the information we collect to:</p>
      <ul>
          <li>Provide and improve our services</li>
          <li>Communicate with you</li>
          <li>Customize your experience</li>
          <li>Analyze usage patterns</li>
          <li>Protect against fraud and abuse</li>
      </ul>

      <h2>Data Sharing</h2>
      <p>We may share your information with third-party service providers to facilitate our services, but we do not sell or rent your personal information to third parties for marketing purposes.</p>

      <h2>Security</h2>
      <p>We take reasonable measures to protect your data from unauthorized access, alteration, or disclosure. However, no method of transmission over the internet or electronic storage is 100% secure, so we cannot guarantee absolute security.</p>
  </div>
 </div>
 <Footer/>
    </div>
  )
}

export default Marketing